import React from 'react';
import './logo.css';

const Logo = ({ isPastSobreSection }) => {
  return (
    <div className={`logo__container ${isPastSobreSection ? 'past-sobre' : ''}`}>
      <span className="logo__name">ANDRÉ PARREIRA</span>
      <span className="logo__specialty">PSICÓLOGO</span>
    </div>
  );
};

export default Logo;
